export default __webpack_public_path__ + "static/media/office-hel.8ecc60c0.svg";